import React from 'react';

import {Career} from '../../components';

export default Career;


// WEBPACK FOOTER //
// ./src/pages/career/index.js